import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { api } from "@/api";
import { toast } from "react-toastify";
import { loadHandbooks } from "@/utils/loadHandbooks";

interface ICreateRequisiteForm {
  displayName: string;
  inn: number;
  kpp: string;
  ogrn: string;
  bankAccount: string;
  bankName: string;
  bik: string;
  correspondentAccount: string;
  address: string;
  phone: string;
  email: string;
  currency: number;
  billable: boolean;
}

const createRequisiteFields: InputField[] = [
  {
    label: "Название",
    name: "displayName",
    placeholder: "Название счёта",
    type: "text",
    isRequired: true,
  },
  {
    label: "ИНН",
    name: "inn",
    placeholder: "1234567890",
    type: "text",
    isRequired: true,
  },
  {
    label: "КПП",
    name: "kpp",
    placeholder: "123456789",
    type: "text",
    isRequired: false,
  },
  {
    label: "ОГРН",
    name: "ogrn",
    placeholder: "1234567890123",
    type: "text",
    isRequired: false,
  },
  {
    label: "Расчетный счет",
    name: "bankAccount",
    placeholder: "12345678901234567890",
    type: "text",
    isRequired: true,
  },
  {
    label: "Название банка",
    name: "bankName",
    placeholder: "Название банка",
    type: "text",
    isRequired: true,
  },
  {
    label: "Валюта",
    name: "currency",
    placeholder: "Валюта",
    type: "currency",
    isRequired: true,
  },
  {
    label: "БИК",
    name: "bik",
    placeholder: "123456789",
    type: "text",
    isRequired: true,
  },
  {
    label: "Корреспондентский счет",
    name: "correspondentAccount",
    placeholder: "12345678901234567890",
    type: "text",
    isRequired: true,
  },
  {
    label: "Адрес",
    name: "address",
    placeholder: "Адрес компании",
    type: "text",
    isRequired: true,
  },
  {
    label: "Телефон",
    name: "phone",
    placeholder: "+71234567890",
    type: "text",
    isRequired: true,
  },
  {
    label: "Email",
    name: "email",
    placeholder: "email@domain.com",
    type: "text",
    isRequired: true,
  },
  {
    label: "Генерировать счета",
    name: "billable",
    type: "boolean",
    placeholder: "Генерировать счета",
    isRequired: false,
    tooltip:
      "Влияет на автоматическую генерацию документов при выставлении счетов",
  },
];

export function CreateRequisiteModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreateRequisiteForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.requisites
        .create(data)
        .then((_data) => {
          loadHandbooks({ handbooks: ["requisites"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание счёта"
      modalErrors={modalErrors}
      fields={createRequisiteFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      defaultValues={{
        billable: false,
      }}
    />
  );
}
